export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/normal-2531badfe0c2d9d5e1862ff9b1b16b55.svg";